import { Helmet } from 'react-helmet';

function Meta(props = {}) {
  const {
    title = "Premium Hair Salon in Sarajevo | Ancy Friz - Expert Styling & Beauty",
    description = "Discover professional hair styling and beauty treatments at Ancy Friz, Sarajevo's premier salon. Expert stylists, premium products, and personalized care. Book your appointment today!",
    url = "https://www.ancyfriz.com/",
    icon = "./favicon.ico",
    author = "Anida Imamović",
    canonical = "https://www.ancyfriz.com/",
    ogTitle = "Premium Hair Salon in Sarajevo | Ancy Friz",
    ogDescription = "Professional hair styling, beauty treatments, and expert care at Ancy Friz. Located in Sarajevo, Bosnia. Book your appointment now!",
    ogImage = "/logo.svg",
    ogUrl = "https://www.ancyfriz.com",
    ogType = "business.business",
    ogSiteName = "Ancy Friz Salon",
    ogLocale = "en_US",
    ogArticleAuthor = "Ancy Friz",
    index = "index",
    follow = "follow",
    keywords = "hair salon sarajevo, beauty salon bosnia, professional haircut, hair styling, hair coloring, salon near me, hairdresser sarajevo",
  } = props;

  // Structured Data for Local Business
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Ancy Friz Hair Salon",
    "image": "/logo.svg",
    "description": description,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Paromlinska 33",
      "addressLocality": "Sarajevo",
      "addressRegion": "Sarajevo Canton",
      "postalCode": "71000",
      "addressCountry": "BA"
    },
    "telephone": "+387 62 741-146",
    "email": "ancyfriz005@gmail.com",
    "url": "https://www.ancyfriz.com",
    "priceRange": "$$",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Sunday",
        "opens": "10:00",
        "closes": "14:00"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/ancyfriz",
      "https://www.instagram.com/ancyfriz"
    ]
  };

  return (
    <Helmet>
      {/* Essential Meta Tags */}
      <meta name="organization" content="Ancy Friz Salon" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#0F1117" />
      <link rel="icon" href={icon} />
      <link rel="canonical" href={canonical || url} />

      {/* Open Graph Tags */}
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={ogSiteName} />
      <meta property="og:locale" content={ogLocale} />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={ogDescription} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:url" content={ogUrl} />
      <meta name="twitter:creator" content={ogArticleAuthor} />

      {/* SEO & Robots */}
      <meta name="robots" content={`${index}, ${follow}`} />
      <meta name="google-site-verification" content="" />
      <meta name="msvalidate.01" content="" />

      {/* Additional SEO Tags */}
      <meta name="language" content="en-US" />
      <meta name="revisit-after" content="7 days" />

      {/* Structured Data (JSON-LD) */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}

export default Meta;
